/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import 'animate.css';

const Indicator = styled.div`
  width: 100%;
  height: 5px;
  border-radius: 5px;
  background-color: #efefef;
  background-size: contain;
  background-position: center;
  box-shadow: ${({ isOnBoarding }) => (isOnBoarding ? 'inset 0 0 0 1000px rgba(0,0,0,.3)' : 'none')};
  opacity: ${({ isOnBoarding }) => (isOnBoarding ? '0.4' : '1')};

  &.correct {
    background-color: green;
  }

  &.wrong {
    background-color: red;
  }
`;

/**
 * This component shows correct and wrong answers of user in the current level
 * until the question that has been answered. The component is located on the bottom of games' page
 *
 */
const GameStatusIndicator = ({
  totalMaterials, doneMaterials, prevTotalMaterials, windowsWidth, isOnBoarding
}) => {
  const Container = styled.div`
  display: flex;
  justify-content: center;
  /* align-items: center; */
`;

  const IndicatorsContainer = styled.div`
    margin-top: 50px;
    padding: 20px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ windowsWidth }) => (windowsWidth < 400 ? '90%' : ((windowsWidth < 750 ? `${(windowsWidth * (-1 / 10) + 130)}%` : '45%')))};
    gap: ${`${70 / (totalMaterials.length)}px`};
  `;
  return (
    <Container windowsWidth={windowsWidth}>
      <IndicatorsContainer windowsWidth={windowsWidth}>
        {
          totalMaterials
            .map(({ oidx }) => ((
              <Indicator
                className={
                  doneMaterials[oidx + prevTotalMaterials]
                    ? `${doneMaterials[oidx + prevTotalMaterials]
                      .split('-')[0]} animate__animated animate__bounce` : null
                }
                isOnBoarding={isOnBoarding}
                totalMaterials={totalMaterials}
              />
            )
            ))
        }
      </IndicatorsContainer>
    </Container>
  );
};

export default GameStatusIndicator;
